import React from 'react';
import StarRatings from 'react-star-ratings';
const formatCurrency = require('format-currency');

const ProviderDetails = ({
	show,
	data,
	close,
	width,
	height,
	left,
	optionalServiceArray,
	horizontal,
	specificIndex,
	onProductPage,
	reviews,
}) => {
	const inlineStylesNormal = {
		width: width ? width : '100%',
		height: height ? height : 'auto',
		left: left ? left : '0',
	};

	const inlineStylesSpecific = {
		width: width ? width : '100%',
		height: height ? height : 'auto',
		right: left ? left : '0',
	};

	if (!data || !data.googlePlacesData) {
		return '';
	}
	const providerServices = data.providerServices;
	return (
		<div
			className={`provider-details
      ${show ? 'active' : ''}
      ${horizontal ? 'horizontal' : ''}
      ${onProductPage ? 'on-product-page' : ''}
      ${specificIndex ? 'specific' : ''}`}
			style={!specificIndex ? inlineStylesNormal : inlineStylesSpecific}>
			<div className="inner">
				<div className="header mt-0">
					{data.locationImageUrl && <img src={data.locationImageUrl} alt="location" />}
					<h4>{data && data.name}</h4>
					<button className="btn" onClick={() => close()}>
						<i className="fas fa-times"></i> Close
					</button>
				</div>
				<table className="table">
					{optionalServiceArray.map((service, index) => {
						var row = providerServices.findIndex(x => x.serviceId === service.ServiceId);

						var mileageCharge = null;
						if (row >= 0) {
							mileageCharge = formatCurrency(providerServices[row].mileageCharge);
						}
						return (
							<tbody key={index}>
								{service.ServiceDescription && (
									<tr>
										<td>{service.ServiceDescription}</td>
									</tr>
								)}

								{service.ServiceLabel && (
									<tr>
										<td>{service.ServiceLabel}</td>
									</tr>
								)}

								{service.FeeMessage && (
									<tr>
										<td>{service.FeeMessage}</td>
									</tr>
								)}

								{service.ProviderMessage && (
									<tr>
										<td>{service.ProviderMessage}</td>
									</tr>
								)}

								<tr>
									<td>{mileageCharge ? `Mileage Fees: $${mileageCharge}` : ''}</td>
								</tr>
							</tbody>
						);
					})}
				</table>

				<h4>Reviews</h4>
				<div className="rating mb-2">
					<StarRatings
						numberOfStars={5}
						rating={parseFloat(reviews.stats.average_rating)}
						starDimension="16px"
						starSpacing="0"
						starRatedColor="#FF9966"
						starEmptyColor="grey"
					/>
					<span>({reviews.stats.average_rating})</span>
					<span> {reviews.stats.total_reviews} Reviews</span>
				</div>

				{reviews ? (
					<div className="testimonials">
						{reviews.reviews.map((data, index) => {
							return (
								<blockquote className="blockquote" key={index}>
									<p className="mb-0">{data.comments}</p>
									<div className="blockquote-footer">
										<span className="mr-1">
											{data.reviewer.first_name} {data.reviewer.last_name}
										</span>
										<StarRatings
											numberOfStars={5}
											rating={data.rating}
											starDimension="14px"
											starSpacing="0"
											starRatedColor="#FF9966"
											starEmptyColor="grey"
										/>
									</div>
									<p className="mt-1">{data.date}</p>
								</blockquote>
							);
						})}
					</div>
				) : (
					<></>
				)}
			</div>
		</div>
	);
};

export default ProviderDetails;
